interface ICurrency {
  _id: string
  name: string
  symbol: string
  symbol_position: string
  iso_code: string
  createdAt: Date
  updatedAt: Date
}

export interface IAvailableBalance {
  _id: string
  price: number
  level?: string
  claimed: boolean
  currency?: ICurrency
  enable: boolean
  onlyForLevel: boolean
  management: string
  createdBy: string
  createdAt: Date
}

export class AvailableBalance {
  id: string
  price: number
  level?: string
  claimed: boolean
  currency?: ICurrency
  enable: boolean
  onlyForLevel: boolean
  management: string
  createdBy: string
  createdAt: Date
  constructor(from: IAvailableBalance) {
    this.id = from._id
    this.price = from.price
    this.level = from.level
    this.claimed = from.claimed
    this.currency = from.currency
    this.enable = from.enable
    this.onlyForLevel = from.onlyForLevel
    this.management = from.management
    this.createdBy = from.createdBy
    this.createdAt = from.createdAt
  }
}
